import React from 'react';
import styles from '../styles/NotificationPermissionModal.module.css';

/**
 * NotificationPermissionModal - Modal to request notification permissions
 *
 * Explains the value of notifications for staying engaged with financial goals
 */
function NotificationPermissionModal({ onAllow, onDismiss }) {
  return (
    <div className={styles.overlay} onClick={onDismiss}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onDismiss}>✕</button>

        <div className={styles.icon}>🔔</div>

        <h2 className={styles.title}>Stay on Track with Your Goals</h2>

        <p className={styles.description}>
          Life gets busy. Most people who start working on their finances fall off track within the first week.
        </p>

        <p className={styles.description}>
          <strong>Gentle reminders from Sophia</strong> help you:
        </p>

        <ul className={styles.benefits}>
          <li>
            <span className={styles.checkmark}>✓</span>
            <span>Keep momentum when life gets hectic</span>
          </li>
          <li>
            <span className={styles.checkmark}>✓</span>
            <span>Remember to complete your next action step</span>
          </li>
          <li>
            <span className={styles.checkmark}>✓</span>
            <span>Stay accountable to the goals you set</span>
          </li>
          <li>
            <span className={styles.checkmark}>✓</span>
            <span>Build the habit that leads to real change</span>
          </li>
        </ul>

        <p className={styles.highlight}>
          People who enable notifications are <strong>3x more likely</strong> to achieve their financial goals.
        </p>

        <div className={styles.actions}>
          <button className={styles.allowButton} onClick={onAllow}>
            Enable Reminders
          </button>
          <button className={styles.skipButton} onClick={onDismiss}>
            Maybe Later
          </button>
        </div>

        <p className={styles.privacy}>
          We'll only send helpful reminders when you need them. You can turn them off anytime.
        </p>
      </div>
    </div>
  );
}

export default NotificationPermissionModal;
